import { attachAuthInterceptors } from '@repo/auth/axios';
import axios from 'axios';

import { authClient } from 'src/app/auth/auth-client';

const agent = axios.create();

attachAuthInterceptors(agent, authClient);

export { agent as defaultAgent };
